import { useState, useEffect } from 'react'
import { VITE_API_BASE } from '../config/apiConfig'

const API = VITE_API_BASE

export default function VideoOrders() {
  const [orders, setOrders] = useState([])
  const [loading, setLoading] = useState(true)
  const [filter, setFilter] = useState('all')

  useEffect(() => {
    loadOrders()
  }, [])

  const loadOrders = () => {
    fetch(`${API}/video-orders`)
      .then(r => r.json())
      .then(d => {
        if (d.success) setOrders(d.data || [])
      })
      .catch(() => {
        setOrders([
          { id: 'VO001', type: 'growth', childName: '张小明', product: '成长故事·标准版', price: 69, status: 'completed', createdAt: '2026-04-17' },
          { id: 'VO002', type: 'painting', childName: '李小明', product: '画作动画', price: 99, status: 'processing', createdAt: '2026-04-16' },
          { id: 'VO003', type: 'ai', childName: '王小明', product: 'AI动画单次', price: 39, status: 'pending', createdAt: '2026-04-15' },
          { id: 'VO004', type: 'growth', childName: '陈小丽', product: '生日特别版', price: 299, status: 'completed', createdAt: '2026-04-14' },
          { id: 'VO005', type: 'ai', childName: '赵小明', product: 'AI动画10次套', price: 299, status: 'completed', createdAt: '2026-04-13' },
        ])
      })
      .finally(() => setLoading(false))
  }

  const getTypeBadge = (type) => {
    const map = { growth: '#1890ff', painting: '#722ed1', ai: '#eb2f96' }
    const labels = { growth: '成长记录', painting: '画作动画', ai: 'AI动画' }
    return <span style={{ padding: '2px 8px', borderRadius: 10, fontSize: 11, background: map[type], color: '#fff' }}>{labels[type]}</span>
  }

  const getStatusBadge = (status) => {
    const map = {
      pending: { bg: '#fffbe6', color: '#faad14', text: '待处理' },
      processing: { bg: '#e6f4ff', color: '#1890ff', text: '制作中' },
      completed: { bg: '#f6ffed', color: '#52c41a', text: '已完成' },
    }
    const s = map[status] || map.pending
    return <span style={{ padding: '2px 10px', borderRadius: 10, fontSize: 12, background: s.bg, color: s.color }}>{s.text}</span>
  }

  const filtered = filter === 'all' ? orders : orders.filter(o => o.type === filter)

  if (loading) return <div style={{ padding: 40 }}>加载中...</div>

  return (
    <div>
      <h2 style={{ fontSize: 20, marginBottom: 20 }}>📹 视频订单管理</h2>

      {/* Filters */}
      <div style={{ display: 'flex', gap: 12, marginBottom: 20 }}>
        {[
          { key: 'all', label: '全部', count: orders.length },
          { key: 'growth', label: '成长记录', count: orders.filter(o => o.type === 'growth').length },
          { key: 'painting', label: '画作动画', count: orders.filter(o => o.type === 'painting').length },
          { key: 'ai', label: 'AI动画', count: orders.filter(o => o.type === 'ai').length },
        ].map(f => (
          <button
            key={f.key}
            onClick={() => setFilter(f.key)}
            style={{
              padding: '10px 20px',
              border: 'none',
              borderRadius: 6,
              cursor: 'pointer',
              fontSize: 13,
              background: filter === f.key ? '#1890ff' : '#f5f5f5',
              color: filter === f.key ? '#fff' : '#666'
            }}
          >
            {f.label} ({f.count})
          </button>
        ))}
      </div>

      {/* Table */}
      <div style={{ background: '#fff', borderRadius: 8, overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ background: '#fafafa' }}>
              <th style={th}>订单号</th>
              <th style={th}>类型</th>
              <th style={th}>孩子</th>
              <th style={th}>产品</th>
              <th style={th}>金额</th>
              <th style={th}>状态</th>
              <th style={th}>时间</th>
              <th style={th}>操作</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map(o => (
              <tr key={o.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                <td style={td}>{o.id}</td>
                <td style={td}>{getTypeBadge(o.type)}</td>
                <td style={td}>{o.childName}</td>
                <td style={td}>{o.product}</td>
                <td style={{ ...td, color: '#f5222d', fontWeight: 500 }}>¥{o.price}</td>
                <td style={td}>{getStatusBadge(o.status)}</td>
                <td style={{ ...td, color: '#999' }}>{o.createdAt}</td>
                <td style={td}>
                  {o.status === 'completed' && (
                    <button style={{ ...btn, background: '#1890ff', color: '#fff' }}>查看</button>
                  )}
                  {o.status === 'processing' && (
                    <span style={{ color: '#1890ff' }}>制作中...</span>
                  )}
                  {o.status === 'pending' && (
                    <button style={{ ...btn, background: '#52c41a', color: '#fff' }}>开始</button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Stats */}
      <div style={{ marginTop: 20, display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16 }}>
        <div style={card}>
          <div style={{ color: '#999', fontSize: 12 }}>总收入</div>
          <div style={{ fontSize: 24, color: '#52c41a' }}>¥{orders.reduce((s, o) => s + o.price, 0)}</div>
        </div>
        <div style={card}>
          <div style={{ color: '#999', fontSize: 12 }}>已完成</div>
          <div style={{ fontSize: 24, color: '#52c41a' }}>{orders.filter(o => o.status === 'completed').length}</div>
        </div>
        <div style={card}>
          <div style={{ color: '#999', fontSize: 12 }}>制作中</div>
          <div style={{ fontSize: 24, color: '#1890ff' }}>{orders.filter(o => o.status === 'processing').length}</div>
        </div>
        <div style={card}>
          <div style={{ color: '#999', fontSize: 12 }}>待处理</div>
          <div style={{ fontSize: 24, color: '#faad14' }}>{orders.filter(o => o.status === 'pending').length}</div>
        </div>
      </div>
    </div>
  )
}

const card = { background: '#fff', borderRadius: 8, padding: 16, boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }
const th = { padding: 14, textAlign: 'left', fontSize: 13, color: '#666' }
const td = { padding: 14, fontSize: 13 }
const btn = { padding: '6px 14px', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 12 }
